module.exports = __webpack_public_path__ + "static/media/blue.e44a6294.gif";